import { useWindowSize } from 'Core/hooks/useWindowSize';

export function useShowSidebar() {
  const { width } = useWindowSize();
  const breakpoint = 1200;

  return width >= breakpoint;
}
